<template>
  <div class="modal-card" style="width: auto;" id="showChanges">
    <div class="modal-card-head">
      <div class="level" style="width:100%">
        <div class="level-left">
          <!--<div class="level-item">
            <div style="marign-right: 15px;" v-if="changes.length > 2">
              <fa class="is-hoverable" icon="chevron-left" size="2x" @click="$refs.carousel.advancePage('backward')"></fa>
            </div>
          </div>-->
          <div class="level-item">
            <div class="modal-card-title block">
              <b>Change Details</b><br />
              <span style="font-size:0.7em"><b>{{changes[0].Group}} ({{changes[0].Period}})</b></span> <br />
            </div>
          </div>
        </div>
        <!--<div class="level-right">
          <div class="level-item">
            <fa class="is-hoverable" v-if="changes.length > 2" icon="chevron-right" size="2x" @click="$refs.carousel.advancePage()"></fa>
          </div>
        </div>-->
      </div>
    </div>
    <div class="modal-card-body" id="changeLog">
      <div style="margin: 20px 10%;">
        <b-field v-show="changes.length > 1">
          <b-slider v-model="diffs"
                    type="is-info"
                    :min="0"
                    :max="changes.length - 1"
                    :custom-formatter="formatTicks"
                    ticks
                    @input="GetAugmentation(diffs[0], diffs[1])"></b-slider>
        </b-field>

        <!--<b-field>
          <div class="columns" v-show="changes.length > 1">
            <div class="column">Quick selections:</div>
            <div class="column"><a href="#" @click="setDiffs('mostRecent')">Most recent</a></div>
            <div class="column"><a href="#" @click="setDiffs('all')">All changes</a></div>
          </div>
        </b-field>-->
        <div class="breathe-md">
          <div class="is-pulled-left">
            <span style="cursor:pointer" @click="setDiffs('newer')">&lt; Newer</span>
          </div>
          <div class="is-pulled-right">
            <span style="cursor:pointer" @click="setDiffs('older')">Older &gt;</span>
          </div>
        </div>
        <div style="clear:both">&nbsp;</div>

        <div class="columns">
          <div class="column newer">
            <b-field label="Changed by" v-show="changes.length > 0">
              <div>{{changes[diffs[0]].User}}</div>
            </b-field>
            <b-field label="Changed on">
              <div>{{changes[diffs[0]].Stamp | moment('M/DD/YYYY h:mm:ss a') }} UTC</div>
            </b-field>

          </div>
          <div class="column older" v-show="changes.length > 1">
            <b-field label="Previous save authored by">
              <div>{{changes[diffs[1]].User}}</div>
            </b-field>
            <b-field label="Saved on">
              <div>{{changes[diffs[1]].Stamp | moment('M/DD/YYYY h:mm:ss a') }} UTC</div>
            </b-field>
          </div>
        </div>
      </div>

      <b-field label="Question">
        <div v-html="changes[0].Question"></div>
      </b-field>

      <div>
        <label class="label">Response Text</label>
        <b-notification :closable="false" class="loading" v-show="augmenting">
          &nbsp;
          <b-loading active :is-full-page="false"></b-loading>
        </b-notification>
        <p v-html="augment" v-show="!augmenting"></p>
      </div>

      <!--<div class="carousel" v-if="changes.length >= 1">
        <carousel :navigationEnabled="false" :scrollPerPage="true" :perPage="1" ref="carousel">
          <slide v-for="(change, index) in changes" id="needsMargin">
            <b-notification :closable="false" v-show="augmenting">
              &nbsp;
              <b-loading active></b-loading>
            </b-notification>
            <p v-html="Augment(change.Answer,)"></p>
          </slide>
        </carousel>
      </div>-->
      <div v-if="changes.length < 1">
        <p class="has-text-centered">
          No changes to compare
        </p>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button class="button is-primary" @click="$parent.close()">Close</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        diffs: [0, this.changes.length - 1],
        augmenting: false,
        augment: ""
        //now: this.$moment(),
        //later: this.$moment().add('m', -45)
      }
    },
    props: {
      changes: Array,
    },
    computed: {
      ShortQuestion() {
        return this.changes[0].Question.substring(0, 50) + "..."
      }
    },
    methods: {
      formatTicks(val) {
        return this.changes[val].User + " - " + this.$moment(this.changes[val].Stamp).utc(this.changes[val].Stamp).fromNow();
      },
      setDiffs(param) {
        //console.log(this.diffs);
        if (param == 'mostRecent')
          this.diffs = [0, 1];
        else if (param == 'all')
          this.diffs = [0, this.changes.length - 1];
        else if (param == 'newer') {
          if (this.diffs[0] > 0) {
            this.diffs[0]--;
            this.diffs = this.diffs.slice(0);
          }
        }
        else if (param == 'older') {
          if (this.diffs[1] < this.diffs.length) {
            this.diffs[1]++;
            this.diffs = this.diffs.slice(0);
          }
        }
      },
      async GetAugmentation(i, j) {
        if (!this.augmenting) {
          this.augmenting = true;
          var changeA = this.changes[i];
          var changeB = this.changes[j];
          const response = await this.$http.post("api/report/augment", { text1: changeA.Answer, text2: changeB.Answer });
          this.augmenting = false;
          this.augment = response.data;
          //this.$http.post("api/report/augmentOptions", { text1: changeA.Answer, text2: changeB.Answer });
        }
      }
    },
    mounted() {
      //console.log(this.changes);
      //Test code
      //var stamp = this.changes[0].Stamp;
      //var moment = this.$moment(stamp).utc(stamp);
      //console.log(moment);
      //console.log(moment.fromNow());
    }
  }
</script>

<style>
  #changeLog.modal-card-body {
    overflow-x: hidden;
    overflow-y: auto;
  }

  label.label.left {
    left: 0 !important;
  }

  .VueCarousel-slide {
    margin-right: 15px !important;
  }

  #changeLog .newer {
    background-color: #edf7fe;
    padding: 10px;
  }

  #changeLog .older {
    background-color: #ffeeee;
    padding: 10px;
  }
</style>
